import styled from '@emotion/styled';
import React from 'react';

import { theme } from '../../theme/theme';

interface RoundIconWrapperRootCSSProperties extends React.CSSProperties {
  '--size'?: string;
  '--color'?: string;
  '--border-radius'?: string;
}

interface RoundIconWrapperProps {
  color?: string;
  size?: string;
  borderRadius?: string;
  style?: RoundIconWrapperRootCSSProperties;
  children?: React.ReactNode;
}

export function RoundIconWrapper(props: RoundIconWrapperProps) {
  const { color, size, borderRadius, style, children, ...rest } = props;

  return (
    <RoundIconWrapper.S.Root
      {...rest}
      style={{
        ...style,
        '--border-radius': borderRadius,
        '--size': size,
        '--color': color,
      }}
    >
      {children}
    </RoundIconWrapper.S.Root>
  );
}

function SRoundIconWrapper() {}
RoundIconWrapper.S = SRoundIconWrapper;

SRoundIconWrapper.Root = styled.span<{ style: RoundIconWrapperRootCSSProperties }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--size, ${theme.icon.size_default});
  height: var(--size, ${theme.icon.size_default});
  border: 0;
  border-radius: var(--border-radius, 50%);
  flex: 0 0 auto;
  outline: 0;
  background: var(--color, ${theme.color.icon_light});
`;
